/**
 *
 * Section PrivacyPolicy
 *
 */
import PropTypes from "prop-types";

function PrivacyPolicy(props) {
  return (
    <div class="row">
      <div class="col">
        <div className="step" id="privacyPolicy">
          <div
            className="buttonClose"
            onClick={(e) => props.emitChangeSection("closeSection", e)}
          >
            &nbsp;
          </div>
          <h1>I am am h1</h1><p>h1 p1 text</p><p>h1 p2 text</p><h1>I am a h2</h1><p>h2 p1  text</p><p>h2 p2  text</p><p>h2 p3  text</p><h1>I am a h3</h1><p>h2 p1  text</p>
        </div>
      </div>
    </div>
  );
}

PrivacyPolicy.propTypes = {
  emitChangeSection: PropTypes.func, // Change step
};
export default PrivacyPolicy;
